import styled from "styled-components";

export const CategoriesContent = styled.div`
    padding-bottom: 3.125rem;
`;